module.exports = __webpack_public_path__ + "img/virtualjobfair.5f9d729b.jpg";